function isExternalUrl(url) {
  try {
    const urlObject = new URL(url, window.location.href);
    const currentLocation = new URL(window.location.href);
    if (!urlObject.protocol.startsWith("http")) {
      return urlObject.protocol === "mailto:" || urlObject.protocol === "tel:";
    }
    return urlObject.hostname !== currentLocation.hostname || urlObject.port !== currentLocation.port;
  } catch {
    return false;
  }
}
export {
  isExternalUrl
};
//# sourceMappingURL=isExternalUrl.js.map
